"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInquiryOrderDetailSearchModel = instanceOfInquiryOrderDetailSearchModel;
exports.InquiryOrderDetailSearchModelFromJSON = InquiryOrderDetailSearchModelFromJSON;
exports.InquiryOrderDetailSearchModelFromJSONTyped = InquiryOrderDetailSearchModelFromJSONTyped;
exports.InquiryOrderDetailSearchModelToJSON = InquiryOrderDetailSearchModelToJSON;
exports.InquiryOrderDetailSearchModelToJSONTyped = InquiryOrderDetailSearchModelToJSONTyped;
/**
 * Check if a given object implements the InquiryOrderDetailSearchModel interface.
 */
function instanceOfInquiryOrderDetailSearchModel(value) {
    return true;
}
function InquiryOrderDetailSearchModelFromJSON(json) {
    return InquiryOrderDetailSearchModelFromJSONTyped(json, false);
}
function InquiryOrderDetailSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'iodFormNo': json['iodFormNo'] == null ? undefined : json['iodFormNo'],
    };
}
function InquiryOrderDetailSearchModelToJSON(json) {
    return InquiryOrderDetailSearchModelToJSONTyped(json, false);
}
function InquiryOrderDetailSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'iodFormNo': value['iodFormNo'],
    };
}
